"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNetworkSettingValid = exports.validateBlockChainIdentifier = void 0;
const zod_1 = require("zod");
const enums_1 = require("../enums");
const errors_1 = require("../errors");
const IdentifierSchema = zod_1.z.union([
    zod_1.z.object({
        blockchainRid: zod_1.z.undefined(),
        blockchainIid: zod_1.z.number(),
    }),
    zod_1.z.object({
        blockchainRid: zod_1.z.string(),
        blockchainIid: zod_1.z.undefined(),
    }),
]);
const NodeUrlSchema = zod_1.z.union([
    zod_1.z.object({
        nodeUrlPool: zod_1.z.union([zod_1.z.string(), zod_1.z.array(zod_1.z.string())]),
        directoryNodeUrlPool: zod_1.z.undefined(),
    }),
    zod_1.z.object({
        nodeUrlPool: zod_1.z.undefined(),
        directoryNodeUrlPool: zod_1.z.union([zod_1.z.string(), zod_1.z.array(zod_1.z.string())]),
    }),
]);
const RestNetworkSettingsSchema = zod_1.z.object({
    statusPollingInterval: zod_1.z.number().optional(),
    statusPollingCount: zod_1.z.number().optional(),
    failOverConfig: zod_1.z
        .object({
        strategy: zod_1.z.nativeEnum(enums_1.FailoverStrategy).optional(),
        attemptsPerEndpoint: zod_1.z.number().optional(),
        attemptInterval: zod_1.z.number().optional(),
        unreachableDuration: zod_1.z.number().optional(),
    })
        .optional(),
});
const validateBlockChainIdentifier = (networkSettings, options) => {
    const { throwOnError = false } = options || {};
    const identifierValidationContext = IdentifierSchema.safeParse(networkSettings);
    if ("error" in identifierValidationContext) {
        const missingBlockchainIdentifierError = new errors_1.MissingBlockchainIdentifierError();
        if (throwOnError) {
            throw missingBlockchainIdentifierError;
        }
        return {
            success: identifierValidationContext.success,
            error: identifierValidationContext.error,
            message: missingBlockchainIdentifierError.message,
        };
    }
    return { success: true };
};
exports.validateBlockChainIdentifier = validateBlockChainIdentifier;
const validateNodeUrl = (networkSettings, options) => {
    const { throwOnError = false } = options || {};
    const nodeUrlValidationContext = NodeUrlSchema.safeParse(networkSettings);
    if ("error" in nodeUrlValidationContext) {
        const missingNodeUrlError = new errors_1.MissingNodeUrlError();
        if (throwOnError) {
            throw missingNodeUrlError;
        }
        return {
            success: nodeUrlValidationContext.success,
            error: nodeUrlValidationContext.error,
            message: missingNodeUrlError.message,
        };
    }
    return { success: true };
};
const validateRestNetworkSettings = (networkSettings, options) => {
    const { throwOnError = false } = options || {};
    const restNetworkSettingsValidationContext = RestNetworkSettingsSchema.safeParse(networkSettings);
    if ("error" in restNetworkSettingsValidationContext) {
        const { error: { issues } = {} } = restNetworkSettingsValidationContext;
        const errorMessage = issues === null || issues === void 0 ? void 0 : issues.map(({ message, path }) => `${path[0]}: ${message}`).join(", ");
        if (throwOnError) {
            throw new Error(errorMessage);
        }
        return {
            success: restNetworkSettingsValidationContext.success,
            error: restNetworkSettingsValidationContext.error,
            message: errorMessage,
        };
    }
    return { success: true };
};
const isNetworkSettingValid = (networkSettings, options) => {
    const identifierValidationContext = (0, exports.validateBlockChainIdentifier)(networkSettings, options);
    if ("error" in identifierValidationContext) {
        return identifierValidationContext;
    }
    const nodeUrlValidationContext = validateNodeUrl(networkSettings, options);
    if ("error" in nodeUrlValidationContext) {
        return nodeUrlValidationContext;
    }
    const restNetworkSettingsValidationContext = validateRestNetworkSettings(networkSettings, options);
    if ("error" in restNetworkSettingsValidationContext) {
        return restNetworkSettingsValidationContext;
    }
    return { success: true };
};
exports.isNetworkSettingValid = isNetworkSettingValid;
//# sourceMappingURL=networkSettings.js.map